import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import { makeStyles } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-cycle
import { ChipItemType } from '../filter/FilterInner';

const useStyles = makeStyles((theme) => ({
    root: {
        borderWidth: theme.typography.pxToRem(1),
        borderStyle: 'solid',
        borderRadius: theme.typography.pxToRem(15),
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        lineHeight: theme.spacing(16 / 8),
        height: theme.spacing(32 / 8),
        justifyContent: 'space-between',
        letterSpacing: theme.spacing(0.4 / 8),
        position: 'relative',
        outline: 'none',
    },
    iconWrap: {
        width: theme.spacing(28 / 8),
        height: theme.spacing(28 / 8),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: theme.spacing(1 / 8),
    },
    icon: {
        cursor: 'pointer',
        '&:hover, &:focus': {
            width: theme.spacing(28 / 8),
            height: theme.spacing(28 / 8),
        },
    },
    label: {
        flexShrink: 0,
        marginLeft: theme.spacing(12 / 8),
        marginRight: (props: Props): number | string =>
            props.onRemove ? theme.spacing(6 / 8) : theme.spacing(12 / 8),
        '&::selection': {},
    },
    inputBox: {
        minWidth: theme.spacing(20),
        display: 'flex',
        marginLeft: (props: Props): number | string =>
            props.onRemove ? theme.spacing(6 / 8) : 0,
        marginRight: (props: Props): number | string =>
            props.onRemove ? theme.spacing(6 / 8) : theme.spacing(12 / 8),
    },
    input: {
        '& ::selection': {},
    },
}));

interface Props {
    label: string;
    onChange: ((value: string) => void) | ((value: number | undefined) => void);
    onRemove?: () => void;
    value: string | number | null;
}

interface BooleanVariantProps {
    inputType: ChipItemType.boolean;
}

const FilterChipBoolean: React.FC<Props & BooleanVariantProps> = (props) => {
    const { label, onRemove } = props;

    const classes = useStyles(props);
    return (
        <div className={classes.root}>
            <p className={classes.label}>{label}</p>
            {onRemove !== undefined && (
                <div className={classes.iconWrap}>
                    <CancelIcon
                        onClick={(event): void => {
                            event.stopPropagation();
                            onRemove();
                        }}
                        className={classes.icon}
                    />
                </div>
            )}
        </div>
    );
};

export default FilterChipBoolean;
